import { IconButton, InputAdornment, Stack } from '@mui/material';
import { InputText } from 'app/components/elements/InputText';
import React, { ChangeEvent } from 'react';
import { ButtonCustom } from 'app/components/elements/ButtonCustom';
type HeaderValidationProps = {
  searchText: string;
  setSearchText: (text: string) => void;
  onSearch: () => void;
  textFilter?: string;
  clearFilter?: () => void;
  buttons?: {
    text: string;
    type: string;
    onClick: () => void;
  }[];
};
export const HeaderValidation = ({
  searchText,
  setSearchText,
  onSearch,
  buttons,
  textFilter,
  clearFilter
}: HeaderValidationProps) => {
  return (
    <Stack
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
      }}>
      <Stack flexDirection={'row'} gap={4}>
        <Stack flexDirection={'row'} gap={1.25}>
          <Stack gap={1}>
            <InputText
              startAdornment={
                <InputAdornment position="end">
                  <IconButton>
                    <img alt={'icon-user'} src={'/icons/icon_search.svg'} width={24} />
                  </IconButton>
                </InputAdornment>
              }
              placeholder={'Search'}
              inputProps={{
                value: searchText,
                style: {
                  width: '352px',
                  minHeight: '46px',
                  height: '46px',
                  padding: 0
                },
                onChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                  setSearchText(event.target.value);
                },
                onKeyDown: (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                  if (event.key === 'Enter') {
                    onSearch();
                  }
                }
              }}
            />
          </Stack>
          <ButtonCustom
            sx={{ width: 'max-content', height: '46px' }}
            label={'Search'}
            onClick={onSearch}
          />
        </Stack>
        {clearFilter && (
          <Stack flexDirection={'row'} gap={1.25}>
            <Stack gap={1}>
              <InputText
                placeholder={'Filter'}
                inputProps={{
                  value: textFilter,
                  disabled: true,
                  style: {
                    width: '200px',
                    minHeight: '46px',
                    height: '46px',
                    padding: 0
                  }
                }}
              />
            </Stack>
            <ButtonCustom
              sx={{ width: 'max-content', height: '46px' }}
              label={'Clear Filter'}
              onClick={clearFilter}
            />
          </Stack>
        )}
      </Stack>
      <Stack style={{ flexDirection: 'row', gap: '20px' }}>
        {buttons?.map((item, index) => (
          <ButtonCustom
            key={index}
            isSecondary={item.type === 'secondary'}
            sx={{ width: 'max-content', height: '46px' }}
            label={item.text}
            onClick={item.onClick}
          />
        ))}
      </Stack>
    </Stack>
  );
};
